export function plano(numero: string | number): string {
    if (!numero && numero !== 0) return '';
    if (typeof numero === 'number' && !Number.isFinite(numero)) return '';

    const numeroStr = numero.toString().trim();
    if (numeroStr === 'NaN' || numeroStr === '') return '';

    if (numeroStr.includes('.')) {
        const partes = numeroStr.split('.');
        const parteInteira = partes[0].replace(/\./g, '');
        const parteDecimal = partes[1] || '';

        if (!parteInteira && !parteDecimal) return '';

        const numInteiro = Number(parteInteira);
        const parteInteiraFormatada =
            parteInteira && Number.isFinite(numInteiro)
                ? numInteiro.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                : '0';

        return parteDecimal ? `${parteInteiraFormatada}.${parteDecimal}` : parteInteiraFormatada;
    }

    const apenasNumeros = numeroStr.replace(/\D/g, '');
    if (!apenasNumeros) return '';

    const num = Number(apenasNumeros);
    return Number.isFinite(num) ? num.toLocaleString('pt-BR') : '';
}

export function planoParaNumero(valorFormatado: string): number {
    if (!valorFormatado || valorFormatado.trim() === '') return 0;

    const numeroStr = valorFormatado.replace(/\./g, '').replace(',', '.');
    const numero = parseFloat(numeroStr);

    return isNaN(numero) ? 0 : numero;
}

export function formatValorUnitario(valor: string | number): string {
    if (!valor && valor !== 0) return '';
    if (typeof valor === 'number') {
        if (!Number.isFinite(valor)) return '';
        return formatValorComDecimais(valor, 4, false);
    }
    const num = parseFloat(String(valor).trim().replace(',', '.'));
    return Number.isFinite(num) ? formatValorComDecimais(num, 4, false) : '';
}

export function parseValorApi(valor: string | number): number {
    if (valor !== 0 && !valor) return 0;
    if (typeof valor === 'number') return Number.isFinite(valor) ? valor : 0;
    const str = String(valor).trim();
    if (!str) return 0;
    const semVirgulas = str.replace(/,/g, '');
    const num = parseFloat(semVirgulas);
    return Number.isFinite(num) ? num : 0;
}


export function formatValorMensal(valor: number): string {
    if (!Number.isFinite(valor)) return '';
    // Sempre mostrar 2 casas decimais, mesmo quando o valor é 0
    const partes = Number(valor).toFixed(2).split('.');
    const parteInteira = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    // Garantir que sempre tenha 2 dígitos decimais
    const parteDecimal = partes[1] || '00';
    return `${parteInteira},${parteDecimal.padEnd(2, '0')}`;
}

export function formatValorComDecimais(valor: number, casasDecimais: number = 4, decimalComPonto: boolean = false): string {
    if (!Number.isFinite(valor)) return '';
    const partes = Number(valor).toFixed(casasDecimais).split('.');
    const parteInteira = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const sep = decimalComPonto ? '.' : ',';
    return `${parteInteira}${sep}${partes[1]}`;
}

export function formatQuantidadeComRaw(
    raw: { isRaw: boolean; value: string },
    valor: number
): string {
    if (raw.isRaw) return raw.value;
    return valor ? plano(valor) : '';
}

export function formatQuantidadeRangeComRaw(
    rawValue: string | undefined,
    rangeMax: number | '' | undefined
): string {
    if (rawValue !== undefined) return rawValue;
    if (rangeMax === '' || rangeMax === undefined) return '';
    return plano(rangeMax);
}

export function formatValorMensalComRaw(
    raw: { isRaw: boolean; value: string },
    valor: number
): string {
    if (raw.isRaw) return raw.value;
    return typeof valor === 'number' && Number.isFinite(valor) ? formatValorMensal(valor) : '';
}

export function formatValorUnitarioPre(valor: number): string {
    return typeof valor === 'number' && Number.isFinite(valor) ? formatValorComDecimais(valor, 4, true) : '';
}